import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { EntryPoints } from './components/entry-points';
export const CnEntryPoints = withI18n(EntryPoints, {
    locale,
    componentName: 'CnEntryPoints',
    _noHoc: true,
});
